// extracted by mini-css-extract-plugin
module.exports = {"center":"text-input_center__3_C7V"};